import {module} from "./modules/pro/pro.module.js";
export * from "./services/pro/index.js";
export * from "./controllers/pro/index.js";
export * from "./filters/pro/index.js";
export * from "./components/pro/index.js";
export * from "./modules/pro/index.js";
export const angularJsModule = module;
